<template>
  <form class="modal__form" @submit.prevent="">
    <header class="modal__header">
      <h2>{{ $t("login.title") }}</h2>

      <div class="img" @click="$emit('close')">
        <img src="/media/inpulse-template-ac-new-a/close.svg" alt="close">
      </div>
    </header>

    <div class="fields">
      <label v-for="field in formFields" :key="field.name" :class="[{field_error: field.error}]">
        <span>{{field.name}}</span>
        <input v-model="field.value" :type="field.name === 'Password' ? passwordType : field.type" required>
        <span v-show="field.error" class="error">{{field.errorMessage}}</span>

<!--        <span v-show="field.type === 'password'" class="show-password">-->
<!--          <img v-show="!showPassword" class="show_off" src="/media/inpulse-template-ac-new-a/eye.svg" alt="eye" @click="showPassword = true">-->
<!--          <img v-show="showPassword" class="show_on" src="/media/inpulse-template-ac-new-a/eye_off.svg" alt="eye off" @click="showPassword = false">-->
<!--        </span>-->
      </label>
    </div>

    <custom-button @click="submitForm">
      {{ $t("login.signIn") }}
    </custom-button>

    <footer class="modal__footer">
      <div @click="$emit('close')" style="display:flex;">
        <router-link to="/subscription">{{ $t("login.notMember") }}</router-link>
      </div>
    </footer>
  </form>
</template>

<script>
import { EventBus } from '../../../../EventBus';

export default {
  name: "Register",

  data() {
    return {
      loading: false,
      showPassword: false,
      formFields: [
        {
          name: this.$t("login.email.title"),
          type: "email",
          value: "",
          error: false,
          errorMessage: this.$t("login.email.error"),
          validate() {
            return this.value.length > 0;
          },
        },
        {
          name: this.$t("login.password.title"),
          type: this.passwordType,
          value: "",
          error: false,
          errorMessage: this.$t("login.password.error"),
          validate() {
            return this.value.length > 0;
          },
        },
      ],
    };
  },

  computed: {
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
    session() {
      return this.$root.$children[0].$refs.session
    }
  },

  methods: {
    submitForm() {
      let errors = false;

      for (const field of this.formFields) {
        field.error = !field.validate();
        errors = errors || field.error;
      }
      if (errors) return
      if (this.loading) return
      this.loading = true

      EventBus.$emit('show-preloader')

      var formData = new FormData()

      formData.append('csrfmiddlewaretoken', this.session.info.csrf_token)
      formData.append('email', this.formFields[0].value)
      formData.append('password', this.formFields[1].value)

      fetch('/customer/login/', {
        method: 'POST',
        body: formData,
      })
          .then(r => {
            this.loading = false
            EventBus.$emit('hide-preloader')

            if (r.status == 400) {
              alert('Login or password incorrect, please review form')
            }
            return r.json()
          })
          .then(data => {
            if (data.status == 'ok') {
              this.$emit('changeModal', null)
              EventBus.$emit('redirect-to-dashboard')
            }
          })
    },
  },
}
</script>